import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS } from '../../_config';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import { useForm, Controller } from 'react-hook-form';
import { useStoreSelector, useAuthStatus, useCompanyLogoSelector } from '../../store/selectors/userSelector';
import { useStoreApi } from '../../store/api/hooks/storeApiHook';
import { useDataSourceApi } from '../../store/api/hooks/dataSourceApiHook';
import Select from 'react-select';
import toast from 'react-hot-toast';
import Spinner from '../../components/iconSvgs/spinner';

const Branches: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [branches, setBranches] = useState<any[]>([]);
    const [selectedBranch, setSelectedBranch] = useState<any>(null);

    const storeAPI: any = useStoreApi();
    const dataSourceAPI = useDataSourceApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const store = useStoreSelector();
    const companyLogo = useCompanyLogoSelector();
    const dispatch = useDispatch();
    // console.log('store =>', store?.store_id);

    const { control, formState: { errors }, handleSubmit, } = useForm<any>();

    const getBranches = (data: any) => {
        storeAPI.getStoreBranches(data, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            setBranches(resp.data);
        }, (err: any) => {
            toast.error(err);
        })
    }


    const onSubmit = () => {
        setOnSubmitLoading(true);
        const param: any = {
            branch_id: selectedBranch?.branch_id,
        }
        try {
            setTimeout(() => {
                dataSourceAPI.getDataSource(param, (msg: any, resp: any) => {
                    if (resp?.code === 200) {
                        if (resp.data.length > 0) {
                            let inPending: any = null;
                            let failure: any = null;
                            const completed = resp?.data.find((item: any) => item.last_fetch_status === 'completed');
                            if (!completed) {
                                inPending = resp?.data.find((item: any) => item.last_fetch_status === 'pending');
                                if (!inPending) {
                                    failure = resp?.data.find((item: any) => item.last_fetch_status !== 'completed' && item.last_fetch_status !== 'pending');
                                }
                            }
                            const rawPayload = completed || inPending || failure;
                            const branchPayload = {
                                ...rawPayload,
                                branch_id: rawPayload?.branch_id ?? selectedBranch?.branch_id,
                                branch_name: rawPayload?.branch_name ?? selectedBranch?.branch_name,
                                store_id: rawPayload?.store_id ?? store?.store_id,
                            };
                            dispatch({
                                type: ACTIONS.STORE.GET_BRANCH,
                                payload: branchPayload,
                            })
                            navigate(URLS.MODULE_SELECTION);
                        }
                    } else if (resp?.code === 404) {
                        // toast.error(resp?.message);
                        const payload = {
                            source_type: null,
                            url: null,
                            last_fetch_date: null,
                            created_at: null,
                            ds_id: null,
                            store_id: store?.store_id,
                            branch_id: selectedBranch?.branch_id,
                            branch_name: selectedBranch?.branch_name,
                            snapshot_id: null,
                            last_fetch_status: null
                        }
                        dispatch({
                            type: ACTIONS.STORE.GET_BRANCH,
                            payload: payload,
                        })
                        // navigate(URLS.DATASOURCES.CREATE);
                        navigate(URLS.MODULE_SELECTION);
                    }
                }, (error: any, resp: any) => {
                    console.log('error =>', error, resp);
                    if (resp?.detail?.code === 404) {
                        // toast.error(resp?.detail?.message);
                        const payload = {
                            source_type: null,
                            url: null,
                            last_fetch_date: null,
                            created_at: null,
                            ds_id: null,
                            store_id: store?.store_id,
                            branch_id: selectedBranch?.branch_id,
                            branch_name: selectedBranch?.branch_name,
                            snapshot_id: null,
                            last_fetch_status: null
                        }
                        // console.log('payload =>,', payload);
                        dispatch({
                            type: ACTIONS.STORE.GET_BRANCH,
                            payload: payload,
                        })
                        navigate(URLS.MODULE_SELECTION);
                        // navigate(URLS.DATASOURCES.CREATE); THIS ONE WAS LAST ACTIVE
                        // navigate(URLS.SETTINGS);
                    } else {
                        // toast.error("Something went wrong");
                    }
                })
                setOnSubmitLoading(false);
            }, 5000);
        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    useEffect(() => {
        if(store?.store_id){
            getBranches({store_id: store?.store_id});
        }
    }, [store]);

    return (
        <div className="flex min-h-screen">
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            {/* Left Side: Form Section */}
            <div className="flex flex-col justify-center w-full md:items-center md:w-2/5 lg:w-[35%] px-5 sm:px-8 py-8 sm:py-10 lg:px-10 bg-white">
                <div className="w-full sm:max-w-2xl">
                    <img className="h-15 w-auto mb-8 sm:mb-12" src={companyLogo || "/assets/images/Frame_2.png"} alt="company logo" />
                    <h2 className="mt-10 text-left text-2xl font-bold tracking-tight text-gray-900">Branches</h2>
                    <p className="mt-1 text-left text-base tracking-tight text-gray-500">Choose a branch store</p>
                </div>

                <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-5">
                            <div className="mt-2">
                                <Controller
                                    name="branch"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={branches.map((brn: any) => ({
                                                value: brn.branch_id,
                                                label: brn.branch_name,
                                            }))}
                                            placeholder="Branch"
                                            isSearchable={false}
                                            value={selectedBranch ? { value: selectedBranch.branch_id, label: selectedBranch.branch_name } : null}
                                            onChange={(option: any) => {
                                                field.onChange(option);
                                                const found = branches.find((b: any) => b.branch_id === option?.value) ?? null;
                                                setSelectedBranch(found);
                                            }}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderRadius: '2px',
                                                    borderColor: errors.branch ? '#ef4444' : state.isFocused ? '#3b82f6' : '#d1d5db',
                                                    borderWidth: '1px',
                                                    boxShadow: 'none',
                                                    '&:hover': { borderColor: state.isFocused ? '#3b82f6' : '#d1d5db' },
                                                    minHeight: '36px',
                                                    fontSize: '14px',
                                                    backgroundColor: 'white',
                                                    width: '100%',
                                                }),
                                                placeholder: (base) => ({ ...base, color: '#9ca3af', fontSize: '14px' }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    color: state.isSelected ? 'white' : '#6b7280',
                                                    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#eff6ff' : 'white',
                                                    fontSize: '14px',
                                                }),
                                                singleValue: (base) => ({ ...base, color: '#6b7280', fontSize: '14px' }),
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className="mb-5">
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-sm bg-blue-500 py-3.5 sm:py-4 text-base sm:text-sm font-semibold text-white shadow-sm hover:bg-blue-600 transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Submit
                            </button>
                        </div>
                    </form>


                </div>
            </div>

            <div className="hidden md:block md:w-3/5 lg:w-[65%] bg-cover" style={{ backgroundImage: 'url(/assets/images/2148204009-1.jpg)' }}>
            </div>
        </div>
    );
};

export default Branches;